import JobsEmployeer from "../../components/employeer/jobs";

const JobsEmployeerPage = () => {
  return <JobsEmployeer />;
};

export default JobsEmployeerPage;
